import {
	type ExperienceData,
	type PageLoadExperienceData,
} from '@atlassian/ufo-experimental/types';

import { type FeatureFlagClient, type FeatureFlagValue } from '../../../types';

type FeatureFlagsPluginPayload = {
	featureFlags: { [key: string]: FeatureFlagValue };
} | null;

export const featureFlags = (
	featureFlagClient: FeatureFlagClient,
	featureFlags: string[],
	data: ExperienceData | PageLoadExperienceData,
): FeatureFlagsPluginPayload => {
	const allFeatureFlags = [...featureFlags, ...(data.featureFlags || [])];

	if (allFeatureFlags.length === 0) {
		return null;
	}

	const initialMemo: [string, Partial<FeatureFlagValue>][] = [];
	allFeatureFlags.reduce((memo, featureFlagKey) => {
		const ffVal = featureFlagClient.getValue(featureFlagKey);
		if (ffVal !== undefined && ffVal !== null) {
			memo.push([featureFlagKey, ffVal]);
		}
		return memo;
	}, initialMemo);

	const mappedFeatureFlags = Object.fromEntries(initialMemo);

	return {
		featureFlags: mappedFeatureFlags,
	};
};
